import styled from 'styled-components';
import { Col, Row, Select } from 'antd';

import { DefaultImg } from 'app/components/StyledCarousel';
import { DESKTOP_WIDTH, MOBILE_WIDTH } from 'app/hooks/useWindowSize';

export const TicketContainer = styled(Row)`
  padding: 24px 0;
  @media (max-width: ${DESKTOP_WIDTH - 1}px) {
    padding: 16px 0;
  }
`;

export const Thumb = styled.img`
  border-radius: 16px;
  aspect-ratio: 7 / 9;
  width: 100%;
  object-fit: cover;
  @media (max-width: ${DESKTOP_WIDTH - 1}px) {
    height: 324px;
  }
  @media (max-width: ${MOBILE_WIDTH}px) {
    height: 237px;
  }
`;

export const TicketName = styled.h3`
  font-weight: 600;
  font-size: 18px;
  color: #000000;
  margin-bottom: 5px;
  line-height: 23px;
  @media (max-width: ${DESKTOP_WIDTH - 1}px) {
    margin: 8px 0 4px 0;
  }
`;

export const Catalog = styled.h4`
  font-weight: 600;
  font-size: 16px;
  color: #000000;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 30px;
  margin-bottom: 5px;
  @media (max-width: ${DESKTOP_WIDTH - 1}px) {
    white-space: break-spaces;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const PriceBLock = styled(Col)`
  min-width: 140px;
`;

export const ListedPrice = styled.del`
  color: #808080;
  font-size: 14px;
  font-weight: 400;
  @media (max-width: ${DESKTOP_WIDTH - 1}px) {
    margin-left: -16px;
  }
`;

export const PromotionalPrice = styled.p`
  color: #e92127;
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  @media (max-width: ${DESKTOP_WIDTH - 1}px) {
    margin-left: -16px;
  }
`;

export const PositionAndTimeBlock = styled(Row)`
  margin-top: 13px;
`;

export const StyledSelect = styled(Select)<{ isError?: boolean }>`
  width: 133px;
  &.ant-select {
    .ant-select-selector {
      border: none;
      border-bottom: solid 1px
        ${props => (props.isError ? '#E92127' : '#ededed')};
      border-radius: 0;
      padding-left: 0;
    }
    &:hover {
      .ant-select-selector {
        border-color: ${props => (props.isError ? '#E92127' : '#ededed')};
      }
    }
    .ant-select-arrow {
      right: 4px;
    }
  }
  @media (max-width: ${DESKTOP_WIDTH - 1}px) {
    width: 100%;
  }
`;

export const Time = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .time-title {
    margin: 0;
    font-size: 14px;
    color: #808080;
    .booking-time {
      font-weight: 600;
    }
  }
`;

export const ErrMess = styled.p`
  margin: 0;
  margin-top: 4px;
  color: #e55015;
  font-size: 14px;
  font-style: italic;
  width: max-content;
  max-width: 100%;
`;

export const SelectPopupContainer = styled.div`
  & > div:first-child {
    z-index: 1;
  }
`;

export const StyledDefaultImg = styled(DefaultImg)`
  aspect-ratio: 7 / 9;
  height: auto;
  @media (max-width: ${DESKTOP_WIDTH - 1}px) {
    height: 324px;
  }
  @media (max-width: ${MOBILE_WIDTH}px) {
    height: 237px;
  }
`;
